module.exports = __webpack_public_path__ + "static/images/static-map.3ezmueH.png";